import {FunctionComponent, useState} from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from "@mui/material";
import {parse} from "date-fns";

const BgcReviewedModal: FunctionComponent<{
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (adverseActionDate: Date) => Promise<void>;
}> = ({isOpen, onClose, onConfirm}) => {
    const [date, setDate] = useState<string>('');

    async function handleConfirm() {
        const parsedDate = parse(date, 'yyyy-MM-dd', new Date());
        await onConfirm(parsedDate);
        setDate('');
        onClose();
    }

    return (
        <Dialog
            open={isOpen}
            sx={{'& .MuiDialog-paper': {width: '50%'}}}
        >
            <DialogTitle>Adverse Action Window - Set here after Checkr</DialogTitle>
            <DialogContent>
                <Box sx={{mb: 2, mt: 2}}>
                    <TextField
                        label={'Adverse Action Window'}
                        type={"date"}
                        value={date}
                        InputLabelProps={{shrink: true}}
                        onChange={(e) => setDate(e.target.value)}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleConfirm} disabled={!date}>Confirm</Button>
            </DialogActions>
        </Dialog>
    );
};

export default BgcReviewedModal;
